/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Dvc_Search_Details_RequiredInputs */

const en_task_dvc_search_details_required = /** @type {(inputs: Task_Dvc_Search_Details_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a search type and provide the value to search for.`)
};

const pt_br2_task_dvc_search_details_required = /** @type {(inputs: Task_Dvc_Search_Details_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o tipo de consulta e informe o dado a ser pesquisado.`)
};

/**
* | output |
* | --- |
* | "Select a search type and provide the value to search for." |
*
* @param {Task_Dvc_Search_Details_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_dvc_search_details_required = /** @type {((inputs?: Task_Dvc_Search_Details_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Dvc_Search_Details_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_dvc_search_details_required(inputs)
	return pt_br2_task_dvc_search_details_required(inputs)
});